export type TeamMemberStatus = 'ENABLED' | 'BLOCKED' | 'DISABLED' | 'PENDING' | 'PENDING_APPROVAL';

export type TeamMemberRole = 'ADMIN' | 'BASIC';

export enum TeamStatus {
  APPROVED = 'approved',
  REJECTED = 'rejected'
}

export interface TeamMember {
  uuid: string;
  account_number: string;
  fullname: string,
  email: string,
  role: TeamMemberRole;
  disposable: number | null;
  monthly_limit: number | null;
  status: TeamMemberStatus;
  _member: any;
}

export interface CreateUserForm {
  uuid?: string;
  email: string;
  name: string;
  lname: string;
  slname?: string;
  password?: string;
  role: TeamMemberRole;
  monthly_limit: string;
  phone: string;
  account_uuid?: string;
  origin: {
    source: string;
  };
}

export interface UserDetails {
  uuid: string;
  email: string;
  name: string;
  lname: string;
  slname?: string;
  role: TeamMemberRole;
  monthly_limit: number;
  phone: string;
  status: TeamMemberStatus;
  account?: {
    balance: boolean;
    accounts: Array<any>;
    account_count: number;
  }
  customer?: {
    general: any;
    credit_line: any;
    customer_uuid_afb: string;
    uuid: string;
    company_id: string;
  }
  customer_uuid: string;
  approved_by?: string;
  cdate?: string;
  udate?: string;
  account_uuid?: string;

}

export interface UserToEdit {
  uuid: string;
  customer_uuid: string;
  email: string;
  name?: string;
  lname?: string;
  slname?: string;
  phone?: string;
  role?: TeamMemberRole;
  monthly_limit?: number;
  account_uuid?: string;
  account?: {
    balance: boolean;
    accounts: Array<any>;
    account_count: number;
  }
}

export interface UserToApprove {
  user_uuid: string;
  customer_uuid: string;
  monthly_limit?: number;
  status?: TeamStatus;
}

export type AddUserFormValues = Omit<CreateUserForm, 'monthly_limit'> & { monthly_limit: number };
export type EditUserFormValues = Omit<CreateUserForm, 'monthly_limit'> & { monthly_limit: number };
export interface ApproveUserFormValues {
  monthly_limit?: number;
  status?: TeamStatus;
  account_uuid?: string;
}

export interface TeamTableProps {
  members: TeamMember[];
  isLoading: boolean;
  pagination: {
    currentPage: number;
    totalPages: number;
    itemsPerPage: number;
    totalItems: number;
    onPageChange: (page: number, limit: number) => void;
  };
  onApprove: (member_uuid: string, values: ApproveUserFormValues, type: TeamStatus) => Promise<void>;
  onGetMember: (member_uuid: string) => Promise<UserDetails | null>;
  onDeactivate: (member_uuid: string) => Promise<void>;
  onUpdate: (member_uuid: string, values: EditUserFormValues) => Promise<void>;
}

export interface PayloadRequest {
  user_uuid?: string;
  customer_uuid?: string;
}

export interface InvitationAceptToken {
  token: string;
}
